import useApiFetch from 'src/app/hooks/useApiFetch';
import DataWrapperChildrenParams from 'src/app/interfaces/dataWrapperChildrenParams';
import DataWrapperProps from 'src/app/interfaces/dataWrapperProps';
import {DataWrapperCallback} from 'src/app/interfaces/dataWrapperCallback';
import BaseFetchOptions from 'src/data/api/common/BaseFetchOptions';
import ApiResponseBody from 'src/data/api/responses/ApiResponseBody';
import {EmptyBody} from 'src/data/models/common/emptyBody';
import orderlineService from 'src/data/services/orderlineService';

type ResponseType = ApiResponseBody<EmptyBody>;

interface UnlinkOrderlineDataWrapperChildrenParams extends DataWrapperChildrenParams<ResponseType> {
    unlinkOrderline: (
        orderLineId: string,
        callbacks?: DataWrapperCallback<ResponseType>
    ) => Promise<ResponseType>;
}

type UnlinkOrderlineDataWrapperProps = DataWrapperProps<
    UnlinkOrderlineDataWrapperChildrenParams,
    ResponseType
> &
    BaseFetchOptions;

export const useUnlinkOrderlineDataWrapper = ({
    onError,
    onSuccess,
}: Omit<UnlinkOrderlineDataWrapperProps, 'children'>) => {
    const [{loading, data, errors, resetData}, handleUnlinkOrderline] = useApiFetch<ResponseType>();

    const unlinkOrderline = (
        orderLineId: string,
        callbacks?: DataWrapperCallback<ResponseType>
    ) => {
        return handleUnlinkOrderline(orderlineService.unlinkOrderline(orderLineId), {
            useDefaultErrorHandler: true,
            defaultSuccessMessage: 'Orderline unlinked',
            onFail: () => {
                onError?.();
                callbacks?.onFail?.();
            },
            onSuccess: (data) => {
                onSuccess?.(data);
                callbacks?.onSuccess?.(data);
            },
        });
    };

    return {
        unlinkOrderline,
        data,
        loading,
        errors,
        resetData,
    };
};

export const UnlinkOrderlineDataWrapper = (props: UnlinkOrderlineDataWrapperProps) => {
    const {children} = props;
    const hookData = useUnlinkOrderlineDataWrapper(props);

    if (!children) return <></>;

    return <>{children(hookData)}</>;
};
